export default "__VITE_ASSET__cde0fb5c__"